import { Route } from '@angular/router';

export const ArticlesRoute: Route = {
  path: 'articles',
  loadComponent() {
    return import('@daas-consulting/production/shared/frontend/pages').then(
      (c) => c.LayoutBase2PageComponent
    );
  },
  loadChildren() {
    return import(
      '@daas-consulting/production/shared/frontend/articles_shell'
    ).then((c) => c.articlesShellRoutes);
  },
};
